﻿/**
 * Cookie-Class
 */
var cok = /** @class */ (function() {
    function cok() {
        var _this = this;
    }
    /**
     * Get a cookie
     * @param {String} cname cookie name
     * @return {String} String cookie value
     */
    cok.prototype.getCookie = function(cname) {
            var name = cname + "=";
            var cArr = window.document.cookie.split(';');
            for (var i = 0; i < cArr.length; i++) {
                var c = cArr[i].trim();
                if (c.indexOf(name) == 0)
                    return c.substring(name.length, c.length);
            }
            return "";
        }
        /**
         * Set a cookie
         * @param {String} cname cookie name
         * @param {String} cvalue cookie value
         * @param {Number} exdays number of days before the cookie expires
         */
    cok.prototype.setCookie = function(cname, cvalue, exdays, path) {
            var d = new Date();
            d.setTime(d.getTime() + (exdays * 1000 * 60 * 60 * 24));
            var expires = ";expires=" + d.toUTCString();
            var cPath = path ? path !== '' ? ';path=' + path : '' : ';path=/';
            window.document.cookie = cname + "=" + cvalue + cPath + expires;
        }
        /**
         * Delete a cookie
         * @param {String} cname cookie name
         */
    cok.prototype.deleteCookie = function(cname, path) {
        var d = new Date();
        d.setTime(d.getTime() - (1000 * 60 * 60 * 24));
        var expires = ";expires=" + d.toUTCString();
        var cPath = path ? path !== '' ? ';path=' + path : '' : ';path=/';
        window.document.cookie = cname + "=" + cPath + expires;
    }

    /**
     * Find cookie by regex
     * @params {string} cname
     * @returns {Array}
     */
    cok.prototype.find = function(cname) {
        var re = new RegExp('[; ]' + cname + '=[^\\s;]*', 'g');
        var cList = document.cookie.match(re);
        if (cList) {
            var cResult = [];
            cList.forEach(function(el) {
                var item = {
                    name: el.split('=')[0],
                    value: el.split('=')[1]
                }
                cResult.push(item);
            });
            return cResult;
        }
        return null;
    }

    return cok;
}());

var c = new cok();

/**
 * (de)activate piwik/matomo
 * @param {boolean} activate
 */
function setPiwik(activate) {
    jQuery('input.chkOk').prop('checked',activate);
    if (activate) {
        c.setCookie('_p', 'true', 90, '/');
    } else {
        c.setCookie('_p', 'false', 90, '/');
        // c.deleteCookie( '_p', '/' );
        var pcList = c.find('\_pk\_[^=]*')
        if (pcList) {
            pcList.forEach(function(el) {
                c.deleteCookie(el.name, '/');
            });
        }
    }
}


// jQuery.iDCookieInfo = function(opts) {
//     var $this = this,
//         defaults = {
//             container: '\
//             <div id="{iDCookie}">\
//                     <div class="iDTitle">{title}</div>\
//                     <div class="iDBody">{body}\
//                         <div style="margin-top: .4em">\
//                             <label><input type="checkbox" checked="true" disabled="true" /> Technisch erorderlich</label>\
//                             <label><input type="checkbox" class="chkOk" name="_p" value="true" /> {agree}</label>\
//                             <br />\
//                             <button class="btn btn-primary stat btnAll">Alle akzeptieren</button>\
//                             <button class="btn btn-secondary stat btnSave">Auswahl akzeptieren</button>\
//                             <button class="btnLink btn btn-secondary">{more}</button>\
//                         </div>\
//                     </div>\
//                 </div>\
//                 ',
//             bodyTitle: 'Diese Webseite benutzt Cookies',
//             bodyText: 'Cookies helfen uns bei der nutzerfreundlichen Bereitstellung der Webseite. Durch die Nutzung unserer Dienste erklären Sie sich mit dem Einsatz von Cookies einverstanden.',
//             backgroundColor: '#111111',
//             backgroundOpacity: 0.8,
//             fontColor: '#cccccc',
//             fontSize: '1.2em',
//             titleColor: '#cccccc',
//             titleWeight: 'bold',
//             titleSize: '1.6em',
//             txtBtnOk: 'Statistik (Matomo)',
//             btnOkBgColor: '#2f7c33',
//             txtBtnMore: 'Mehr',
//             btnMoreBgColor: '#2f7c33',
//             moreLink: '', // Wenn leer dann kein llink
//             moreTarget: true, // true: neues Fenster, flase eigenes
//             expire: 30,
//             style: false, // eigenes css einbinden oder default (false) verwenden
//             id: 'iDCookie', // false: eigene ID.
//             cookieName: '_p',
//             cookieValue: 'true'

//         },
//         settings = $.extend(defaults, opts);

//     var cook = c.getCookie(settings.cookieName); // readCookie(settings.cookieName);

//     /** @type {HTMLInputElement} chk */
//     var agbCheck = document.querySelector('.chkOk');
//     if (agbCheck) {
//         registerCokHandler(jQuery(document), settings.id);
//         if (cook === 'true') {
//             agbCheck.checked = true;
//         }
//     }
//     if (cook) {
//         return;
//     }
//     var styles = {
//         container: { position: 'fixed', paddingBottom: '1em', bottom: 0, left: 0, width: '100%', 'background-color': settings.backgroundColor, 'opacity': settings.backgroundOpacity, zIndex: 999999 },
//         title: { color: settings.titleColor, fontWeight: settings.titleWeight, textAlign: 'center', fontSize: settings.titleSize },
//         body: { color: settings.fontColor, textAlign: 'center', fontSize: settings.fontSize, position: 'relative' },
//         agree: { cursor: 'pointer', position: 'realtive', display: 'inline', bottom: '1em', marginLeft: '2em', border: '1px solid #eee', backgroundColor: settings.btnOkBgColor, color: settings.fontColor, textAlign: 'center', padding: '0.2em 0.4em', borderRadius: '0.2em' },
//         more: { cursor: 'pointer', position: 'realtive', display: 'inline', bottom: '1em', marginLeft: '1em', border: '1px solid #eee', backgroundColor: settings.btnMoreBgColor, color: settings.fontColor, textAlign: 'center', padding: '0.2em 0.4em', borderRadius: '0.2em' },
//     }
//     settings.container = settings.container.replace('{iDCookie}', settings.id);
//     settings.container = settings.container.replace('{title}', settings.bodyTitle);
//     settings.container = settings.container.replace('{body}', settings.bodyText);
//     settings.container = settings.container.replace('{agree}', settings.txtBtnOk);
//     settings.container = settings.container.replace('{more}', settings.txtBtnMore);

//     var container = $(settings.container);
//     if (settings.moreLink === '') {
//         container.find('.iDMore').remove();
//     }

//     if (!settings.style) {
//         container.css(styles.container);
//         container.find('.iDTitle').css(styles.title);
//         container.find('.iDBody').css(styles.body);
//         container.find('.iDAgree').css(styles.agree);
//         container.find('.btn').css(styles.agree);
//         container.find('.iDMore').css(styles.more);
//     }

//     registerCokHandler(container, settings.id);


//     /** btnLink link */
//     container.find('.btnLink').on('click', function(event) {
//         if (settings.moreTarget) {
//             window.open(settings.moreLink, '_blank');
//         } else {
//             document.location = settings.moreLink;
//         }
//     });

//     container.hide();
//     $('body').append(container);
//     jQuery('#' + settings.id).slideDown()

// }

function registerCokHandler(container,id) {
    container.find('.stat.btnAll').on('click', function(event) {
        jQuery('#' + id).slideUp();
        setPiwik(true);
    });
    container.find('.stat.btnSave').on('click', function(event) {
        jQuery('#' + id).slideUp();
        setPiwik(document.querySelector('.chkOk').checked);
    });
}
